<template>
  <ContentWrap>
    <el-form ref="queryFormRef" :inline="true" :model="queryParams">
      <el-form-item label="直播间 ID">
        <LiveRoomIdSelect v-model="queryParams.liveId" select-class="!w-260px" />
      </el-form-item>
      <el-form-item label="预约用户">
        <LiveMemberUserSelect v-model="queryParams.userId" select-class="!w-260px" />
      </el-form-item>
      <el-form-item label="预约状态"
        ><el-select v-model="queryParams.status" clearable class="!w-180px"
          ><el-option label="已预约" :value="0" /><el-option label="已取消" :value="1" /></el-select
      ></el-form-item>
      <el-form-item
        ><el-button type="primary" @click="handleQuery"><Icon icon="ep:search" />查询</el-button
        ><el-button @click="resetQuery"><Icon icon="ep:refresh" />重置</el-button></el-form-item
      >
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="记录 ID" prop="id" width="100" />
      <el-table-column label="直播间" min-width="180"
        ><template #default="scope">{{
          roomNames[scope.row.liveId] || `直播 #${scope.row.liveId}`
        }}</template></el-table-column
      >
      <el-table-column label="预约用户" min-width="150"
        ><template #default="scope">{{
          userNames[scope.row.userId] || `用户 #${scope.row.userId}`
        }}</template></el-table-column
      >
      <el-table-column label="状态" width="110"
        ><template #default="scope"
          ><el-tag :type="scope.row.status === 0 ? 'success' : 'info'">{{
            scope.row.status === 0 ? '已预约' : '已取消'
          }}</el-tag></template
        ></el-table-column
      >
      <el-table-column label="是否已提醒" width="120"
        ><template #default="scope">{{
          scope.row.reminded ? '是' : '否'
        }}</template></el-table-column
      >
      <el-table-column
        label="预约时间"
        prop="createTime"
        :formatter="dateFormatter"
        min-width="180"
      />
      <el-table-column
        label="取消时间"
        prop="cancelTime"
        :formatter="dateFormatter"
        min-width="180"
      />
      <el-table-column label="操作" width="90" fixed="right"
        ><template #default="scope"
          ><el-button link type="danger" @click="handleDelete(scope.row.id)"
            >删除</el-button
          ></template
        ></el-table-column
      >
    </el-table>
    <Pagination
      :total="total"
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      @pagination="getList"
    />
  </ContentWrap>
</template>
<script setup lang="ts">
import { dateFormatter } from '@/utils/formatTime'
import * as ReservationApi from '@/api/live/reservation'
import { getRoomPage } from '@/api/live/room'
import { getUserPage } from '@/api/member/user'
import LiveRoomIdSelect from '@/views/live/components/LiveRoomIdSelect.vue'
import LiveMemberUserSelect from '@/views/live/components/LiveMemberUserSelect.vue'
const message = useMessage()
const loading = ref(false),
  list = ref<any[]>([]),
  total = ref(0),
  queryFormRef = ref()
const roomNames = reactive<Record<number, string>>({}),
  userNames = reactive<Record<number, string>>({})
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  liveId: undefined as number | undefined,
  userId: undefined as number | undefined,
  status: undefined as number | undefined
})
const getList = async () => {
  loading.value = true
  try {
    const data = await ReservationApi.getReservationPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}
const resetQuery = () => {
  queryFormRef.value?.resetFields()
  queryParams.liveId = undefined
  queryParams.userId = undefined
  queryParams.status = undefined
  handleQuery()
}
const handleDelete = async (id: number) => {
  await message.delConfirm()
  await ReservationApi.deleteReservation(id)
  message.success('删除成功')
  await getList()
}
/** 加载直播间和会员名称，避免列表只显示业务编号。 */
const loadLookups = async () => {
  const [rooms, users] = await Promise.all([
    getRoomPage({ pageNo: 1, pageSize: 100 }),
    getUserPage({ pageNo: 1, pageSize: 100 })
  ])
  ;(rooms.list || []).forEach((room: any) => (roomNames[room.id] = room.title))
  ;(users.list || []).forEach(
    (user: any) => (userNames[user.id] = user.nickname || user.mobile || `用户 #${user.id}`)
  )
}
onMounted(() => {
  getList()
  loadLookups()
})
</script>
